
import { useAxios } from '@/composables/useAxios';
import type { ApiResponse, IUser } from '@/types/models';

export default () => {
  const findCurrentUserData = async (): Promise<ApiResponse<IUser> | null> => {
    const { callAxios } = useAxios();
    return await callAxios<ApiResponse<IUser>>({
      API: '/api/v1/user/profile',
      method: 'GET',
    });
  };

  return {
    findCurrentUserData,
  };
};
